import Vue from 'vue';
import store from '../store';
import injector from 'vue-inject';
import router from '../router';
Vue.use(injector);

require('./api');
require('./popup');
require('./status');
require('./user');

let api     = injector.get('api'),
    popup   = injector.get('popup'),
    status  = injector.get('status'),
    user    = injector.get('user');

class Settings {
    /**
     * Create temporary settings
     */
    create () {
        this.temporary = store.getters.temporarySettings;
    }

    /**
     * Save settings
     */
    save () {
        return new Promise ((resolve, reject) => {
            let settings = [];
            for (let setting in this.temporary) {
                settings.push(this.temporary[setting]);
            }
            Vue.http.post(api.user.settings.change, {
                userSettings: settings
            }).then(response => {
                user.reloadData(response.data).then(() => {
                    popup.show('Data has been saved successfully!');
                    router.push({ name: 'Profile' });
                    resolve();
                });
            }, error => {
                switch (error.status) {
                    case 422:
                        if (error.data.errors[0].message.toLowerCase().indexOf('google authenticator') > -1) {
                            popup.hide();
                            store.commit('showOtpPage');
                            router.push({ name: 'Otp' });
                        } else {
                            popup.show(error.data.errors[0].message);
                        }
                        break;
                    default:
                        if (status['status' + error.status]) {
                            status['status' + error.status]();
                        }else {
                            popup.show(error.data.errors[0].message);
                        }
                        break;
                }
                reject();
            });
        });
    }
}

injector.service('settings', Settings);



// WEBPACK FOOTER //
// ./src/services/settings.js